export interface ICartLineItem {
  amount: number;
  description: string;
  code: string;
  quantity: number;
  min: number;
  max: number;
  value: string;
  noUnit: boolean;
  disabled: boolean;
  lineItemType: string;
  defaultQuantity: number;
}

export interface ICartState {
  readonly cartType?: string;
  readonly minAmount?: number;
  readonly totalRawAmount?: number;
  readonly totalAmount?: number;
  readonly totalQuantity?: number;
  readonly defaultLoaded?: boolean;
  readonly lineItems?: any;
  readonly defaultLineItems?: any;
  readonly paymentCollectionId?: string;
  readonly walkoverId?: string;
}

export type ICartSelector = ICartState

export enum CartActionTypes {
  RESET_CART = 'redux-app/carts/RESET_CART',
  UPDATE_CART = 'redux-app/carts/UPDATE_CART',
}

export default null;
